export interface ColumnConfig {
  field: string;
  header: string;
  visible: boolean;
  width?: string;
  minWidth?: string;
  filterType?: 'input' | 'multiselect' | 'custom';
}

export const COLUMN_CONFIG: ColumnConfig[] = [
  {
    field: 'name',
    header: 'Название',
    visible: true,
    width: '11%',
    minWidth: '100px'
  },
  {
    field: 'id',
    header: '№ наряда',
    visible: true,
    width: '8%',
    minWidth: '100px'
  },
  {
    field: 'taskType',
    header: 'Тип наряда',
    visible: true,
    width: '11%',
    minWidth: '125px'
  },
  {
    field: 'taskStatus',
    header: 'Статус',
    visible: true,
    width: '6%',
    minWidth: '125px'
  },
  {
    field: 'assetName',
    header: 'Объект',
    visible: true,
    width: '9%',
    minWidth: '100px'
  },
  {
    field: 'departmentName',
    header: 'Участок',
    visible: true,
    width: '10%',
    minWidth: '100px'
  },
  {
    field: 'employees',
    header: 'Исполнители',
    visible: true,
    width: '13%',
    minWidth: '100px'
  },
  {
    field: 'creationDate',
    header: 'Создан',
    visible: true,
    width: '5%',
    minWidth: '118px'
  },
  {
    field: 'actualStartDate',
    header: 'Начало работы (факт)',
    visible: true,
    width: '4%',
    minWidth: '118px'
  },
  {
    field: 'plannedStartDate',
    header: 'Начало работы (план)',
    visible: true,
    width: '4%',
    minWidth: '118px'
  },
  {
    field: 'plannedEndDate',
    header: 'Конец работы (план)',
    visible: true,
    width: '4%',
    minWidth: '118px'
  },
  {
    field: 'actualEndDate',
    header: 'Конец работы (факт)',
    visible: true,
    width: '4%',
    minWidth: '118px'
  },
  {
    field: 'priority',
    header: 'Приоритет',
    visible: true,
    width: '7%',
    minWidth: '40px'
  }
];
